import { render, staticRenderFns } from "./CateSelect.vue?vue&type=template&id=0c0febb2&scoped=true&"
import script from "./CateSelect.vue?vue&type=script&lang=js&"
export * from "./CateSelect.vue?vue&type=script&lang=js&"
import style0 from "./CateSelect.vue?vue&type=style&index=0&id=0c0febb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0febb2",
  null
  
)

export default component.exports